module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.$route.meta.hideRating) ? _c('form-opinion', {
    attrs: {
      "id": _vm.id
    },
    on: {
      "update": function($event) {
        _vm.$emit('update-opinion')
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.opinions), function(item, index) {
    return _c('opinion', {
      key: index,
      attrs: {
        "opinion": item
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38662685","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/wrapperOpinions.vue
// module id = 1095
// module chunks = 1